<script>
import * as Sentry from '@sentry/vue'
import router from '@/router'
import { authComputed, configComputed, configMethods } from '@/store/helpers'
import ErrorBoundary from '@/ErrorBoundary'
import VersionDisplay from '@/components/VersionDisplay.vue'

export default {
	name: 'App',
	components: { ErrorBoundary, VersionDisplay },
	computed: {
		...authComputed,
		...configComputed,
		showModal: {
			get() {
				return !!this.authError
			}
		}
	},
	async created() {
		await this.fetchLocations()

		if (this.loggedIn) {
			Sentry.setUser({
				id: this.currentUser.id,
				email: this.currentUser.email,
				roles: this.currentUser.roles,
				isAdmin: this.isAdmin
			})
		}
	},
	methods: {
		...configMethods,
		handleClick() {
			router.push({ name: 'logout' })
		}
	}
}
</script>

<template>
	<!-- Main App component -->
	<div id="app">
		<ErrorBoundary>
			<RouterView />
		</ErrorBoundary>
		<b-modal
			v-model="showModal"
			centered
			no-stacking
			no-close-on-backdrop
			no-close-on-esc
			hide-header
			hide-footer
		>
			<div class="text-center">
				<i class="mdi mdi-alert-outline h1 text-warning" />
				<!-- TODO: confirm texts and move to translation: -->
				<h4 class="mt-2">Session Expired</h4>
				<p class="mt-3">
					Your login session has expired. Please re-login to continue.
				</p>
				<button
					type="button"
					class="btn btn-warning my-2"
					@click="handleClick"
				>
					Continue
				</button>
			</div>
		</b-modal>
		<VersionDisplay />
	</div>
</template>

<style lang="scss">
@import 'design/app.scss'; // Import all Hyper Theme styles.

img.white-filter {
	filter: brightness(0) invert(1);
}

.custom-radio label,
.cursor-pointer {
	cursor: pointer;
}

input.input-primary:focus {
	border: 1px solid #f16622;
	caret-color: #f16622;
}
</style>
